import { BuildType } from '@/services/ApiService';
import { CredentialsResponse, CredentialTypeModel, QueryCredentialParams, CredentialModel, UserCredentialModel } from '@/types/Credential';

export const credentialApiEndpoints = (build: BuildType) => ({
    getCredentialTypes: build.query<CredentialTypeModel[], void>({
        query: () => 'credential-types',
    }),
    credentials: build.query<CredentialsResponse, QueryCredentialParams>({
        query: params => ({
            url: 'credentials/query',
            method: 'POST',
            body: params,
        }),
        providesTags: ['Credentials'],
    }),
    credentialDetails: build.query<CredentialModel, string>({
        query: id => `credentials/${id}`,
    }),
    favoriteCredential: build.mutation<void, string>({
        query: credentialId => ({
            url: `user-credentials/${credentialId}/favorite`,
            method: 'POST',
        }),
        invalidatesTags: ['Favorites', 'UserCredentials', 'Credentials'],
    }),
    getFavoriteCredentials: build.query<UserCredentialModel[], void>({
        query: () => 'user-credentials/favorites',
        providesTags: ['UserCredentials'],
    }),
});
